import { Component } from 'preact'

const ESC = 27

class Modal extends Component {
  constructor(props) {
    super(props)
    this.body = document.querySelector('body')
    this.handleClick = this.handleClick.bind(this)
    this.handleEsc = this.handleEsc.bind(this)
  }

  componentDidMount() {
    this.body.classList.add('mv-modal-open')
    document.addEventListener('keydown', this.handleEsc)
  }

  componentWillUnmount() {
    this.body.classList.remove('mv-modal-open')
    document.removeEventListener('keydown', this.handleEsc)
  }

  /**
   * If clicked element isn't a child of the modal inner, close modal.
   */
  handleClick(e) {
    const parent = e.target.closest('.mv-modal-inner')
    if (!parent) {
      this.props.onClose()
    }
  }

  /**
   * If escape key is clicked, close modal.
   */
  handleEsc(e) {
    if (e.which === ESC) {
      this.props.onClose()
    }
  }

  render() {
    return (
      <div class="mv-modal" onClick={this.handleClick}> {/* eslint-disable-line */}
        <div class="mv-modal-inner">
          <button class="mv-modal-close" onClick={this.props.onClose}>
            <div class="mv-modal-sr">Close</div>
            &times;
          </button>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Modal
